<template>
  <div :class="applyActiveFolderStyle">
    <NrButton
      class="folder-row-buttons"
      variant="minimal-neutral"
      @click="filterByFolder"
      :aria-label="`Filter by subfolder ${subfolder.child_folder_name}`"
    >
      <NrIcon class="folder" name="sub-folder" />
      <div
        :class="`${
          showChildFolderRename
            ? 'folder-row-with-icon'
            : 'folder-row-without-icon'
        } child-folder-name is-size-7 t--overflow-ellipsis`"
      >
        {{ subfolder.child_folder_name }}
      </div>
    </NrButton>
    <span
      v-if="subfolder.doc_count !== undefined && subfolder.doc_count > 0"
      :class="[
        'folder-doc-count',
        { 'folder-doc-count--active': activeFolder }
      ]"
    >
      {{ subfolder.doc_count }}
    </span>
    <NrIconButton
      v-if="$can('read', 'staff_only_items')"
      class="edit-folder-button folder-row-buttons"
      variant="minimal-neutral"
      :icon="{ name: 'pencil-alt', type: 'regular' }"
      size="small"
      @click="renameFolder"
      :aria-label="`Rename subfolder ${subfolder.child_folder_name}`"
    />
  </div>
</template>

<script>
import NrButton from '@nextrequestco/components/src/components/NrButton'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton'
import NrIcon from '@nextrequestco/components/src/components/NrIcon'

export default {
  props: {
    subfolder: {
      type: Object
    },
    parentFolderId: {
      type: Number
    },
    activeFolder: {
      type: Boolean
    }
  },

  components: {
    NrIcon,
    NrIconButton,
    NrButton
  },

  data() {
    return {
      showChildFolderRename: false
    }
  },

  computed: {
    applyActiveFolderStyle() {
      return [
        'folder-button--child-folder',
        'folder-button',
        {
          'folder-button-active': this.activeFolder
        }
      ]
    }
  },

  methods: {
    filterByFolder() {
      this.$emit('filter-by-folder', {
        parent_folder_id: this.parentFolderId,
        child_folder_id: this.subfolder.id,
        activeId: `${this.parentFolderId}${this.subfolder.id}`,
        type: 'subfolder',
        folderName: this.subfolder.child_folder_name
      })
    },

    renameFolder() {
      this.filterByFolder()
      this.$emit('rename-folder', this.subfolder.child_folder_name)
    }
  }
}
</script>
